export default "__VITE_ASSET__C05yE0$d__"